import React, {useState, setGlobal, getGlobal, useEffect} from 'reactn';
import { Radio, Checkbox, Button, Switch, notification, Popover, Tabs} from 'antd';
import { useFirestore } from 'reactfire';
import Pain from './Pain';
import Discharge from './Discharge';
import HearingLoss from './HearingLoss';
import Tinnitis from './Tinnitis';
import Vertigo from './Vertigo';
import FacialWeakness from './FacialWeakness';

const RightEar = (props) => {
    const {TabPane} = Tabs;

    // setGlobal({
    //     ChiefComplaints_location : {
    //         ...getGlobal().ChiefComplaints_location,
    //     }
    // });

    const docSaved = () => {
        props.hasSaved();
    }

    return (
        <div>
            <React.Fragment>
                <Tabs>
                    <TabPane tab="Pain" key="Pain">
                        <Pain hasSaved={docSaved} />   
                    </TabPane>
                    <TabPane tab="Discharge" key="Discharge">
                        <Discharge hasSaved={docSaved} /> 
                    </TabPane>
                    <TabPane tab="Hearing Loss" key="Hearing Loss">
                        <HearingLoss hasSaved={docSaved} />  
                    </TabPane>
                    <TabPane tab="Tinnitis" key="Tinnitis">
                    <Tinnitis hasSaved={docSaved} />  
                    </TabPane>
                    <TabPane tab="Vertigo" key="Vertigo">
                    <Vertigo hasSaved={docSaved} />  
                    </TabPane>
                    <TabPane tab="Facial Weakness" key="Facial Weakness">
                    <FacialWeakness hasSaved={docSaved} />  
                    </TabPane>
                </Tabs>
            </React.Fragment>
            
        </div>
    );
}

export default RightEar;
